import { DOCUMENT } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { appReducer, profileSelectors } from '@app-root-store';
import { EHeaderProfileTypes } from '@app-root-enums';
import { ThemeService } from '../../root-services/theme.service';
import { HeaderProfileComponent } from '../header-profile/header-profile.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
    public profileTypes = EHeaderProfileTypes;

    @ViewChild(HeaderProfileComponent) headerProfile?: HeaderProfileComponent;

    private store = inject(Store<appReducer.AppState>);
    private document = inject(DOCUMENT);
    public theme = inject(ThemeService);

    public userProfile$ = this.store.pipe(select(profileSelectors.selectProfileUserProfile));
    public selectedProfile$ = this.store.pipe(select(profileSelectors.selectProfileSelectedProfile));

    public focusBasicTemplatesSidenav(): void {
        this.document.getElementById('main-sidenav-basic-templates')?.focus();
    }
}
